/* eslint-disable import/extensions */

// Services - benefit-focused descriptions in wamolabs tone
export const Services = [
  {
    title: 'Web Development',
    tagline: 'Production-ready platforms.',
    description: 'Production-ready web platforms built for scale, speed, and SEO. From marketing sites to complex SaaS dashboards.',
    imageUrl: '/assets/images/Web.png',
    animation: 'left',
  },
  {
    title: 'AI/ML Solutions',
    tagline: 'Models that ship.',
    description: 'Custom models, LLM integrations, and RAG pipelines that turn your data into measurable business outcomes.',
    imageUrl: '/assets/images/AIML.jpg',
    animation: 'up',
  },
  {
    title: 'Mobile Development',
    tagline: 'Native and cross-platform.',
    description: 'Native and cross-platform apps for iOS and Android engineered for performance and growth.',
    imageUrl: '/assets/images/Mobile dev.jpg',
    animation: 'right',
  },
  {
    title: 'UI/UX Design',
    tagline: 'Research-led design systems.',
    description: 'Research-led design systems that drive engagement, conversion, and accessibility from day one.',
    imageUrl: '/assets/images/UI/UX.jpg',
    animation: 'left',
  },
  {
    title: 'DevOps',
    tagline: 'Reliable at scale.',
    description: 'Cloud infrastructure, CI/CD, and observability that keeps your product reliable as it scales.',
    imageUrl: '/assets/images/Devops.jpg',
    animation: 'up',
  },
  {
    title: 'Creative Design',
    tagline: 'Brand systems and motion.',
    description: 'Brand systems, motion, and visual storytelling that make your product unmistakable.',
    imageUrl: '/assets/images/Creative design.jpg',
    animation: 'right',
  },
];

// Stats band (3 metrics)
// TODO: confirm real numbers
export const Stats = [
  { value: '20+', label: 'Clients Served' },
  { value: '15+', label: 'Engineers & Designers' },
  { value: '50+', label: 'Solutions Delivered' },
];

// Capabilities (alternating image/text blocks)
export const Capabilities = [
  {
    title: 'Full-Stack Engineering',
    description: 'End-to-end product engineering — frontend, backend, mobile, and infrastructure. We build with modern stacks (React, Next.js, Node, Python, AWS) so your product ships fast and stays maintainable.',
    imageUrl: '/assets/images/Web.png',
    align: 'right',
  },
  {
    title: 'AI & Machine Learning',
    description: 'From data pipelines to deployed models. We integrate LLMs, build RAG systems, and operationalize ML to turn business problems into measurable outcomes.',
    imageUrl: '/assets/images/AIML.jpg',
    align: 'left',
  },
  {
    title: 'Enterprise Services',
    description: 'Cloud architecture, DevOps, and quality engineering for teams that need reliability at scale. We harden, observe, and automate so your product runs without surprises.',
    imageUrl: '/assets/images/Devops.jpg',
    align: 'right',
  },
];

// Mission section
export const Mission = {
  heading: 'Our Mission',
  body: 'At Web7Labs, we build digital systems that create real momentum for businesses. From scalable platforms to AI-powered solutions, our focus is on technology that performs beyond launch day — fast, accessible, reliable, and built to evolve with your growth.',
  approachHeading: 'Our Approach',
  approachBody: 'We work like an extension of your team — collaborating closely, iterating fast, and staying transparent at every stage. Every project is senior-led, execution-focused, and engineered across all 7 layers of modern digital infrastructure — from strategy and design to development, AI, deployment, and scale.',
  imageUrl: '/assets/images/Teamcollab.jpg',
};

// Full-Stack AI sub-section (used on /services)
export const FullStackAI = [
  {
    title: 'Data Pipelines',
    description: 'Ingest, clean, and prepare data for downstream models and analytics.',
  },
  {
    title: 'Model Development',
    description: 'Custom models trained and tuned to your business problem and data.',
  },
  {
    title: 'LLMs & RAG',
    description: 'Retrieval-augmented generation and LLM apps grounded in your sources.',
  },
  {
    title: 'MLOps',
    description: 'CI/CD, monitoring, and lifecycle management for models in production.',
  },
  {
    title: 'Deployment',
    description: 'Scalable, cost-aware deployment on the cloud or at the edge.',
  },
  {
    title: 'Product Integration',
    description: 'Wiring AI cleanly into your product UX, not bolted on as a chatbot.',
  },
];

// Career value props (Why Web7Labs)
export const CareerValues = [
  {
    title: 'Learn & Grow',
    description: 'Work on cutting-edge projects with senior engineers and designers who actively mentor.',
  },
  {
    title: 'Collaborative Culture',
    description: 'Tight feedback loops, low ego, real ownership. We hire people we want to work with.',
  },
  {
    title: 'Flexible Work',
    description: 'Remote-friendly with flexible hours. Show up, do great work, ship.',
  },
  {
    title: 'Real Impact',
    description: 'Every project ships. You see your work used by real customers, not parked in a backlog.',
  },
];

// Open positions for the Join Us page
export const JobOpenings = [
  {
    id: 'growth-marketing-exec',
    title: 'Growth & Marketing Executive',
    location: 'Lahore',
    openings: 1,
    description: 'Own growth, marketing, and customer acquisition across our software products and services. For an all-rounder who can think about growth, execute campaigns, talk to customers, and turn ideas into measurable results. Freshers are encouraged to apply.',
    tags: ['Growth', 'Digital Marketing', 'Business Development'],
    summary: {
      Team: 'Growth & Marketing',
      Type: 'Full-Time',
      Experience: 'Fresher – 3 Years',
      Openings: '1',
      Salary: 'Competitive',
    },
    skills: ['Lead Generation', 'Outreach & Sales', 'Social Media', 'SEO', 'Email Marketing', 'Paid Ads', 'Analytics'],
    fullDescription: 'Web7Labs is growing, and we’re looking for someone who can take ownership of growth, marketing, and customer acquisition across our software products and services.\n\nThis is not a role limited to social media or lead generation. We’re looking for an all-rounder who can think about growth, execute campaigns, communicate with potential customers, and turn ideas into measurable results.\n\nWe’re looking for someone who wants to build, experiment, and own results — not just complete assigned tasks.\n\nFresh graduates are welcome too — if you’re proactive, a strong communicator, and eager to own results, we’d love to hear from you.',
    responsibilities: [
      'Identify and research potential customers and markets.',
      'Generate and qualify leads through different channels.',
      'Conduct outreach through calls, WhatsApp, email, LinkedIn, and other channels.',
      'Communicate with potential customers and understand their needs.',
      'Present and promote our software products and services.',
      'Manage follow-ups and help convert prospects into customers.',
      'Explore partnerships and new business opportunities.',
      'Plan and execute marketing campaigns.',
      'Develop content and marketing ideas for our products.',
      'Manage and grow our social media presence.',
      'Support product launches and promotional campaigns.',
      'Work on basic SEO, email marketing, and paid marketing.',
      'Research competitors, markets, and customer segments.',
      'Track marketing and growth performance.',
      'Experiment with new acquisition and marketing strategies.',
      'Work closely with the founder and take ownership of assigned growth initiatives.',
    ],
    requirements: [
      '0–3 years of experience in growth, marketing, business development, sales, digital marketing, or a similar role. Fresh graduates with strong communication skills and a genuine interest in growth are encouraged to apply.',
      'Strong communication and interpersonal skills.',
      'Comfortable speaking with customers and business owners.',
      'Strong understanding of marketing and customer acquisition.',
      'Ability to generate ideas and actually execute them.',
      'Comfortable with outreach, follow-ups, and sales conversations.',
      'Good understanding of social media and digital marketing.',
      'Analytical mindset with an interest in measuring results.',
      'Ability to work independently and take ownership.',
      'Comfortable working across multiple products and projects.',
      'Good understanding of software/SaaS products is a plus.',
    ],
    niceToHave: [
      'B2B sales',
      'SaaS or software products',
      'Lead-generation campaigns',
      'Meta Ads / Google Ads',
      'SEO',
      'Email marketing',
      'CRM tools',
      'Content creation',
      'Canva / basic design',
      'Video/content marketing',
      'Product marketing',
    ],
    ratedSkills: [
      'Lead Generation & Outreach',
      'Sales Conversations',
      'Social Media Marketing',
      'SEO / Email Marketing',
      'Paid Ads (Meta / Google)',
      'Work Independently',
    ],
    questions: [
      { name: 'q1', label: 'Years of experience in growth, marketing, sales, or business development (enter 0 if you’re a fresher) *' },
      { name: 'q2', label: 'Share a campaign, project, or initiative you worked on (job, internship, university, or personal) and what it achieved. *' },
    ],
  },
  {
    id: 'marketing-intern',
    title: 'Marketing Intern',
    location: 'Lahore',
    openings: 1,
    description: 'Curious about marketing, content, social media, and how products actually grow? Get hands-on experience creating, experimenting, and contributing to real marketing across our software products.',
    tags: ['Content', 'Social Media', 'Internship'],
    summary: {
      Team: 'Growth & Marketing — Internship',
      Type: 'Internship',
      Experience: 'Students / Fresh Graduates',
      Openings: '1',
    },
    skills: ['Content Creation', 'Social Media', 'Copywriting', 'Canva', 'Video Editing', 'Research'],
    fullDescription: 'Web7Labs is looking for a Marketing Intern to join our team and get hands-on experience working across our software products and digital initiatives.\n\nThis is not just a posting/scheduling internship. You’ll get the opportunity to create, experiment, learn, and contribute to real marketing activities.\n\nYou don’t need to know everything. We’re more interested in someone who is curious, creative, proactive, and willing to learn by doing.',
    responsibilities: [
      'Create content for social media platforms.',
      'Assist with Instagram, Facebook, LinkedIn, and other channels.',
      'Develop posts, graphics, and promotional creatives.',
      'Help create reels and short-form videos.',
      'Assist with basic video editing.',
      'Research content ideas, trends, competitors, and audiences.',
      'Help maintain our content calendar.',
      'Support marketing campaigns and product promotions.',
      'Assist with website and marketing content.',
      'Support basic SEO and digital marketing activities.',
      'Research potential audiences and growth opportunities.',
      'Track basic content and campaign performance.',
      'Come up with new marketing ideas and experiments.',
      'Support the Growth & Marketing Executive with ongoing projects.',
    ],
    requirements: [
      'Strong interest in marketing and digital media.',
      'Good communication and writing skills.',
      'Creative and curious mindset.',
      'Good understanding of social media.',
      'Willingness to learn and experiment.',
      'Ability to take initiative rather than waiting for every instruction.',
      'Good attention to detail.',
      'Comfortable using computers and online tools.',
      'Able to manage multiple small tasks and meet deadlines.',
    ],
    niceToHave: [
      'Canva',
      'Photoshop / Illustrator',
      'CapCut / Premiere Pro',
      'Photography or videography',
      'Copywriting',
      'Social media management',
      'Basic SEO',
      'Digital advertising',
      'Content creation',
    ],
    benefits: [
      'Hands-on experience with real software products.',
      'Exposure to growth and digital marketing.',
      'Opportunity to work on real campaigns and content.',
      'Practical experience beyond classroom learning.',
      'A chance to learn directly within a growing technology company.',
    ],
    ratedSkills: [
      'Content Creation',
      'Social Media',
      'Copywriting',
      'Design (Canva / Photoshop)',
      'Video Editing',
      'Research',
    ],
    questions: [
      { name: 'q1', label: 'Why are you interested in marketing, and what have you created so far? *' },
      { name: 'q2', label: 'Share links to any content, designs, videos, or social pages you’ve worked on. *' },
    ],
  },
  {
    id: 'biz-dev-exec',
    title: 'Business Development Executive',
    location: 'Lahore',
    openings: 3,
    description: 'Drive growth across Client-to-Client (C2C), freelance platforms, and Business-to-Client (B2C) markets. This role is ideal for results-driven hunters with a knack for closing.',
    tags: ['Communication', 'Lead Generation', 'C2C'],
    summary: {
      Team: 'Sales & Growth',
      Experience: 'Fresh Graduate – 1 Year',
      Openings: '3',
      Salary: 'Rs. 50,000 – Rs. 150,000',
    },
    skills: ['Communication', 'Job Hunt', 'Lead Generation', 'C2C', 'MS Office'],
    fullDescription: 'Web7Labs is seeking a motivated and results-driven Business Development Executive to support growth across Client-to-Client (C2C), freelance platforms, and Business-to-Client (B2C) markets. This role is ideal for fresh graduates or early-career professionals passionate about sales, lead generation, and building long-term client relationships.\n\nYou will play a key role in identifying new business opportunities, engaging with potential clients, and supporting the sales pipeline across multiple channels.',
    responsibilities: [
      'Research, identify, and generate qualified leads through online platforms, databases, and outbound channels such as LinkedIn and Upwork.',
      'Develop and execute strategies to acquire and retain customers in C2C and B2C segments.',
      'Initiate first-level communication with prospects and maintain relationships with existing clients to encourage repeat business.',
      'Assist in preparing sales presentations, proposals, pitch decks, and contracts to convert leads into business opportunities.',
      'Track lead generation performance, monitor conversion metrics, and prepare regular reports for leadership.',
      'Support senior business development team members in closing deals and executing sales strategies.',
      'Collaborate with internal teams to ensure service offerings align with client requirements.',
      'Stay informed about industry trends, competitors, and emerging market opportunities.',
      'Participate in industry events, conferences, and networking opportunities to enhance brand visibility.',
    ],
    requirements: [
      'Bachelor’s degree in Business Administration, Marketing, IT, or a related field.',
      'Fresh graduate or up to 1 year of experience in business development, lead generation, or freelancing platforms.',
      'Basic understanding of C2C and freelance business models.',
      'Strong communication, negotiation, and interpersonal skills.',
      'Proficiency in MS Office, Google Workspace, and basic CRM tools.',
      'Self-motivated, detail-oriented, and eager to learn.',
    ],
  },
  {
    id: 'fresh-grads-mern',
    title: 'Fresh Graduates — MERN, Python, AI/ML',
    location: 'Lahore, Pakistan',
    openings: 5,
    description: 'For fresh graduates with strong fundamentals. Work on real client projects, learn modern development practices, and solve meaningful technical problems.',
    tags: ['Python', 'Django', 'FastAPI', 'React'],
    summary: {
      Team: 'Engineering',
      Experience: 'Fresh Graduate',
      Openings: '5',
      Salary: 'Competitive',
    },
    skills: ['JavaScript', 'Python', 'React', 'Node.js', 'SQL', 'Git'],
    fullDescription: 'Join Web7Labs as a fresh graduate engineer working across MERN, Python, and AI/ML stacks. You will work on real client projects with mentorship from senior engineers and gain hands-on experience in modern development practices.',
    responsibilities: [
      'Build and ship features in production codebases under senior mentorship.',
      'Write clean, well-tested code with code reviews and modern Git workflows.',
      'Debug, fix, and improve existing functionality across the stack.',
      'Participate in design discussions, sprint planning, and retros.',
      'Continuously learn modern frameworks (React/Next.js, FastAPI, AI/ML libs).',
    ],
    requirements: [
      'Bachelor’s degree in CS, SE, or related field (or graduating soon).',
      'Solid grasp of data structures, algorithms, and OOP fundamentals.',
      'Working knowledge of at least one modern stack (MERN, Python, or AI/ML).',
      'Strong communication skills and a hunger to learn.',
      'Portfolio, GitHub, or projects you can walk us through.',
    ],
  },
  {
    id: 'internship-django',
    title: 'Internship Program — Django/FastAPI & MERN Stack',
    location: 'Lahore',
    openings: 5,
    description: 'Are you a recent graduate with strong communication skills who is finding it tough to land that first role? Join our hands-on internship program and ramp up fast.',
    tags: ['Python', 'Django', 'MERN'],
    summary: {
      Team: 'Engineering — Internship',
      Experience: 'Fresh Graduate',
      Openings: '5',
      Salary: 'Paid Internship',
    },
    skills: ['Python', 'Django', 'FastAPI', 'React', 'MongoDB', 'REST APIs'],
    fullDescription: 'Our paid internship program is designed for recent graduates and self-taught builders. You will be assigned a mentor and a clear learning roadmap covering Django/FastAPI and MERN stack technologies.',
    responsibilities: [
      'Complete weekly learning sessions with code reviews from senior engineers.',
      'Pair on real client features under mentorship.',
      'Build a portfolio project end-to-end during the program.',
      'Participate in standups, demos, and team retros.',
    ],
    requirements: [
      'Recent graduate or self-taught with strong fundamentals.',
      'Familiarity with Python or JavaScript.',
      'Strong communication skills and a learning mindset.',
      'Available full-time for the duration of the program.',
    ],
  },
  {
    id: 'qa-intern',
    title: 'Quality Assurance (QA) Intern',
    location: 'Lahore, Pakistan',
    openings: 2,
    description: 'For motivated detail-oriented QA Interns. Designed for graduates and freshers who are eager to gain hands-on experience in modern testing.',
    tags: ['Manual Testing', 'End-to-End Testing', 'Regression Testing'],
    summary: {
      Team: 'Quality Engineering',
      Experience: 'Fresh Graduate',
      Openings: '2',
      Salary: 'Paid Internship',
    },
    skills: ['Manual Testing', 'Test Cases', 'Bug Reporting', 'Postman', 'Regression'],
    fullDescription: 'Join our QA team as an intern to learn modern manual and end-to-end testing under mentorship. Hands-on exposure to real product features and bug-hunting workflows.',
    responsibilities: [
      'Write test cases and execute manual + regression test suites.',
      'Report and triage bugs with clear repro steps.',
      'Collaborate with developers on fixes and verification.',
      'Learn end-to-end automation tooling.',
    ],
    requirements: [
      'Bachelor’s in CS or related field (or graduating soon).',
      'Detail-oriented with excellent written communication.',
      'Curiosity to break things and find edge cases.',
    ],
  },
  {
    id: 'ai-ml-intern',
    title: 'AI / ML Intern',
    location: 'Lahore, Pakistan',
    openings: 3,
    description: 'For motivated graduates and freshers eager to build real AI/ML systems. Get hands-on experience with LLMs, model training, and data pipelines under senior mentorship.',
    tags: ['Python', 'Machine Learning', 'LLMs'],
    summary: {
      Team: 'AI Engineering — Internship',
      Experience: 'Fresh Graduate',
      Openings: '3',
      Salary: 'Paid Internship',
    },
    skills: ['Python', 'PyTorch', 'scikit-learn', 'Pandas', 'LLMs', 'Prompt Engineering'],
    fullDescription: 'Join our AI Engineering team as an intern to learn modern machine learning and applied AI under mentorship. You will get hands-on exposure to real datasets, model training and evaluation, and building LLM-powered features that ship to production.',
    responsibilities: [
      'Build, train, and evaluate machine learning models on real datasets.',
      'Prototype LLM-powered features and prompt-engineering workflows.',
      'Clean, explore, and prepare data using Python and Pandas.',
      'Collaborate with senior AI engineers on production pipelines and code reviews.',
      'Continuously learn modern ML/AI tools and frameworks.',
    ],
    requirements: [
      'Bachelor’s in CS, SE, Data Science, or related field (or graduating soon).',
      'Solid Python fundamentals and grasp of core ML concepts.',
      'Familiarity with libraries like NumPy, Pandas, or scikit-learn.',
      'Curiosity about LLMs and applied AI, with a strong learning mindset.',
      'Any projects, notebooks, or GitHub work you can walk us through.',
    ],
  },
  {
    id: 'sys-net-engineer',
    title: 'System & Network Engineer',
    location: 'Lahore, Pakistan',
    openings: 1,
    description: 'For technical and technically-skilled System & Network Engineers with at least 2 years of hands-on experience in networking and system administration.',
    tags: ['Networking', 'Linux', 'Cloud'],
    summary: {
      Team: 'IT & Infrastructure',
      Experience: '2+ Years',
      Openings: '1',
      Salary: 'Competitive',
    },
    skills: ['Linux', 'Cisco', 'Routing & Switching', 'AWS', 'Firewalls', 'Bash'],
    fullDescription: 'We are hiring an experienced System & Network Engineer to own internal networking, system administration, and cloud-edge connectivity for Web7Labs.',
    responsibilities: [
      'Administer Linux/Windows servers, routers, switches, and firewalls.',
      'Monitor network performance and resolve incidents.',
      'Manage user access, VPNs, and security policies.',
      'Plan capacity and document infrastructure changes.',
    ],
    requirements: [
      '2+ years of hands-on experience in networking and sysadmin.',
      'Strong Linux/CLI skills.',
      'Working knowledge of cloud (AWS/Azure/GCP).',
      'Relevant certifications (CCNA, Linux+) a plus.',
    ],
  },
  {
    id: 'senior-ai-llm',
    title: 'Senior AI Automation & LLM Engineer',
    location: 'Lahore',
    openings: 2,
    description: 'For a Senior AI Automation Engineer to design, build, and scale automation workflows and intelligent agent-based systems with multi-agent pipelines and LLMs.',
    tags: ['LLM', 'Python', 'LangChain'],
    summary: {
      Team: 'AI Engineering',
      Experience: '3+ Years',
      Openings: '2',
      Salary: 'Senior — Competitive',
    },
    skills: ['Python', 'LangChain', 'OpenAI', 'RAG', 'Vector DBs', 'FastAPI'],
    fullDescription: 'Lead AI automation initiatives at Web7Labs. Design and ship LLM-powered agents, RAG systems, and multi-agent pipelines that solve real client problems.',
    responsibilities: [
      'Design and build LLM-powered automation pipelines and agents.',
      'Implement RAG systems with production-grade retrieval and evaluation.',
      'Integrate models cleanly into product UX, not bolted-on chatbots.',
      'Mentor mid-level engineers and lead architecture decisions.',
    ],
    requirements: [
      '3+ years building Python services in production.',
      'Hands-on with LLMs, embeddings, and vector databases.',
      'Experience with LangChain/LangGraph or equivalent agent frameworks.',
      'Strong systems thinking and code-quality bar.',
    ],
  },
];

// Hiring process steps
export const HiringProcess = [
  {
    step: 'Step 1',
    title: 'Apply',
    description: 'Share your resume/LinkedIn. Tell us what excites you.',
  },
  {
    step: 'Step 2',
    title: 'Intro Call',
    description: 'A quick conversation about your experience and goals.',
  },
  {
    step: 'Step 3',
    title: 'Technical Interview',
    description: 'Deep-dive into problem solving and real-world scenarios.',
  },
  {
    step: 'Step 4',
    title: 'Culture Add',
    description: 'Meet future teammates. Values, collaboration, and ownership.',
  },
  {
    step: 'Step 5',
    title: 'Offer',
    description: 'Clear compensation, growth path, and immediate impact.',
  },
];

// Career pathways
export const CareerPathways = [
  {
    title: 'Associate Software Engineer',
    description: 'Hone fundamentals, ship features with mentorship, learn delivery.',
  },
  {
    title: 'Software Engineer',
    description: 'Own modules end-to-end. Deliver reliable, well-tested solutions.',
  },
  {
    title: 'Senior Software Engineer',
    description: 'Lead projects, unblock others, and raise the quality bar.',
  },
  {
    title: 'Associate Technical Lead',
    description: 'Mentor, plan sprints, and balance delivery with growth.',
  },
  {
    title: 'Technical Lead',
    description: 'Drive product outcomes, architecture, and team health.',
  },
];

// Early careers info
export const EarlyCareers = {
  heading: 'Early Careers at Web7Labs',
  body: 'Purpose-built for fresh graduates and self-taught builders. Our paid program combines a 2–3 month training track with an assigned mentor and a clear learning roadmap in trending technologies.',
  tags: ['Paid Internship', 'Paid Training (2–3 months)', 'Assigned Mentor'],
  bullets: [
    'Structured onboarding with weekly learning sessions and code reviews',
    'Training roadmap across React/Next.js, Python/FastAPI, AI/ML, and Cloud/AWS',
    'Project rotations to discover your strengths and gain real delivery experience',
  ],
  details: [
    {
      title: 'Internships',
      body: '8–12 week paid internships with mentors, clear deliverables, and a training roadmap.',
    },
    {
      title: 'Training Program (2–3 months)',
      body: 'Paid, mentor-led training in modern stacks: React/Next.js, Python/FastAPI, AI/ML, Cloud/AWS.',
    },
    {
      title: 'Graduate roles',
      body: 'Associate Engineer tracks with a focus on fundamentals, shipping, and ownership.',
    },
  ],
};

// Life at Web7Labs values
export const LifeAtW7L = [
  {
    title: 'Growth Mindset',
    description: 'Continuous improvement over perfection. We learn fast, iterate, and level up.',
  },
  {
    title: 'Ownership & Autonomy',
    description: 'Builders own outcomes. You’ll lead projects and make decisions that matter.',
  },
  {
    title: 'Continuous Learning',
    description: 'Mentorship, learning budgets, and weekly sessions to sharpen your craft.',
  },
  {
    title: 'Impact & Velocity',
    description: 'We ship high-value quickly — balancing quality with real business impact.',
  },
];

// Perks & benefits
export const Perks = [
  { title: 'Performance Bonuses', description: 'Rewarded for impact, not just hours.' },
  { title: 'Generous Paid Time Off', description: 'Time to recharge with planned and casual leave.' },
  { title: 'Learning Budget & Upskilling', description: 'Courses, certifications, and internal sessions.' },
  { title: 'Bi-annual Reviews', description: 'Structured feedback and growth conversations.' },
  { title: 'Hardware & Tools Stipend', description: 'The right gear to do your best work.' },
  { title: 'Hybrid & Remote Flexibility', description: 'Work where you perform best — office or home.' },
  { title: 'Inclusive Culture', description: 'A supportive, people-first environment.' },
  { title: 'Quarterly Team Events', description: 'Regular activities that bring teams together.' },
  { title: 'Annual Retreats', description: 'Company trips to celebrate wins and reset.' },
];

// Join Us FAQ
export const JoinUsFAQ = [
  {
    q: 'Do you hire fresh graduates?',
    a: 'Yes. We run internships and graduate tracks with mentorship and rotations.',
  },
  {
    q: 'What is the interview process?',
    a: 'Apply → intro call → technical interview → culture-add chat → offer. Usually 1–2 weeks end-to-end.',
  },
  {
    q: 'Do you offer paid internships and training?',
    a: 'Yes. Internships are paid, and our 2–3 month training program is paid and mentor-led.',
  },
  {
    q: 'Do you sponsor learning?',
    a: 'Yes. Every engineer gets a learning budget for courses, books, and certifications.',
  },
];

// Join Us dropdown items (header)
export const JoinUsMenu = [
  { name: 'Hiring Process', id: 'hiring-process' },
  { name: 'Open Positions', id: 'open-positions' },
  { name: 'Perks & Benefits', id: 'perks-benefits' },
  { name: 'Career Pathways', id: 'career-pathways' },
  { name: 'Early Careers', id: 'early-careers' },
  { name: 'Life at Web7Labs', id: 'life-at-w7l' },
  { name: 'FAQ', id: 'join-faq' },
];

// Advantages
export const Advantages = [
  [{
    title: 'Communicative',
    description: 'We communicate our project ideas and progress to make it clear.',
    imageUrl: '/assets/images/Communicative.png',
  },
  {
    title: 'Management',
    description: 'We manage our project properly to make our project done well.',
    imageUrl: '/assets/images/Management.png',
  }],
  [{
    title: 'Collaborative​',
    description: 'Our team are very collaborative to make our project done well.',
    imageUrl: '/assets/images/Collaborative.png',
  },
  {
    title: 'Favorite',
    description: "We've did so many project and all of our client love it.",
    imageUrl: '/assets/images/Favourite.png',
  }],
];

export const Portfolios = [];

export const Testimonials = [
  // {
  //   id: 1,
  //   name: 'Sasha Rose',
  //   company: 'Owner, Surveyor Corps',
  //   testimoni: 'Thanks for Web7Labs, you guys are the best! Keep up the great work!',
  //   imageUrl: '/assets/images/Testimonials/Sasha.jpg',
  // },
  // {
  //   id: 2,
  //   name: 'Kruger Khan',
  //   company: 'Director, Shultan Oil',
  //   testimoni: 'I just wanted to let you know that it has been great working with Web7Labs.',
  //   imageUrl: '/assets/images/Testimonials/Kruger.jpg',
  // },
  // {
  //   id: 3,
  //   name: 'Reiner John',
  //   company: 'CEO, Marley CO',
  //   testimoni: 'Web7Labs is so great. Thank you so much for a job well done.',
  //   imageUrl: '/assets/images/Testimonials/Reiner.jpg',
  // },
];

export const TeamMembers = [
  // {
  //   name: 'Rach David',
  //   position: 'CEO',
  //   imageUrl: '/assets/images/TeamMembers/CEO.jpg',
  // },
  // {
  //   name: 'Pauline Sydney',
  //   position: 'HRD',
  //   imageUrl: '/assets/images/TeamMembers/HRD.jpg',
  // },
  // {
  //   name: 'Granger Watterson',
  //   position: 'Finance',
  //   imageUrl: '/assets/images/TeamMembers/Finance.jpg',
  // },
  // {
  //   name: 'Tom Jimmy',
  //   position: 'Project Manager',
  //   imageUrl: '/assets/images/TeamMembers/Project-manager.jpg',
  // },
  // {
  //   name: 'Jim Hendrix',
  //   position: 'Front-end Developer',
  //   imageUrl: '/assets/images/TeamMembers/Frontend1.jpg',
  // },
  // {
  //   name: 'Calvin Max',
  //   position: 'Front-end Developer',
  //   imageUrl: '/assets/images/TeamMembers/Frontend2.jpg',
  // },
  // {
  //   name: 'Don Bizaro',
  //   position: 'Back-end Developer',
  //   imageUrl: '/assets/images/TeamMembers/Backend2.jpg',
  // },
  // {
  //   name: 'Bill Markinson',
  //   position: 'Mobile Developer',
  //   imageUrl: '/assets/images/TeamMembers/Mobile1.jpg',
  // },
  // {
  //   name: 'Igor Kavarov',
  //   position: 'Mobile Developer',
  //   imageUrl: '/assets/images/TeamMembers/Mobile2.jpg',
  // },
  // {
  //   name: 'Freddie Curl',
  //   position: 'UI/UX Designer',
  //   imageUrl: '/assets/images/TeamMembers/UIUX2.jpg',
  // },
  // {
  //   name: 'Monica Lovegood',
  //   position: 'UI/UX Designer',
  //   imageUrl: '/assets/images/TeamMembers/UIUX1.jpg',
  // },
];
